import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Delete as DeleteIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import tools from 'data/common/tools';
import selectors from '../selectors';

class TableHomeProducts extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homeProducts: PropTypes.object.isRequired,
        deleteProduct: PropTypes.func.isRequired
    };

    navigateToProductDetail = rowData => {
        const { history, profile } = this.props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);
        if (
            rowData.state !== 'dissociated' &&
            (profile.get('admin') || (userRights.includes('productsDetails') && userRights.includes(`products_${rowData.productType}_details`)))
        ) {
            return history.push({
                pathname: `/fhe/products/${rowData.homeId}/${rowData.productType}/${rowData.productIdentifier}`
            });
        }
    };

    hasRightToDetail = rowData => {
        const { profile } = this.props;
        return (
            rowData.state !== 'dissociated' &&
            (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`products_${rowData.productType}_details`))
        );
    };

    hasRightToDelete = rowData => {
        const { profile, history } = this.props;
        return profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_${rowData.productType}_delete`);
    };

    hideDeleteButton = rowData => {
        const { profile, history } = this.props;
        const deletableProductType = ['smart_plug'];

        return (
            deletableProductType.includes(rowData.productType) &&
            (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_${rowData.productType}_delete`))
        );
    };

    renderActions = memoizeOne(profile => {
        const { deleteProduct } = this.props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('productsDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToProductDetail,
                hasRight: this.hasRightToDetail,
                tooltip: Translator.translate('general.showDetail')
            });
        }
        actions.row.push({
            icon: DeleteIcon,
            hasRight: this.hasRightToDelete,
            isHidden: this.hideDeleteButton,
            onClick: (rowData, callbackRowActionLoading) => {
                deleteProduct(rowData, callbackRowActionLoading);
            },
            tooltip: Translator.translate(`generic.products.actions.confirmationDeleteProductTitle`)
        });
        return actions;
    });

    renderData = memoizeOne(homeProducts => {
        let result = [];

        homeProducts.map((product, productkey) => {
            result.push({
                id: product.get('id'),
                key: productkey,
                identifier: product
                    .get('identifier')
                    .match(/.{1,2}/g)
                    .join(':'),
                productIdentifier: product.get('identifier'),
                productType: product.get('productType'),
                homeId: parseInt(product.get('homeId')),
                type: product.get('type'),
                label: product.get('label'),
                version: product.get('version'),
                state: product.get('state'),
                status: product.get('status')
            });
        });

        return result;
    });

    renderColumns = memoizeOne(profile => {
        const { classes } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('productsDetails')) && {
                    onClick: this.navigateToProductDetail,
                    hasRight: this.hasRightToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'identifier',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.version'),
                name: 'version',
                customSort: tools.sortVersion
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type',
                grouped: 1
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span className={classes[value]}>{Translator.translate(`general.${value}`)}</span>;
                }
            },
            {
                title: Translator.translate('general.table.column.status'),
                name: 'status',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span className={classes[value]}>{Translator.translate(`general.${value}`)}</span>;
                }
            }
        ];
    });

    render() {
        const { homeProducts, profile } = this.props;

        return (
            <FHETable
                idTable="homeDetailProduct"
                columns={this.renderColumns(profile)}
                data={this.renderData(homeProducts)}
                actions={this.renderActions(profile)}
                minified
                emptyDataSourceMessage={Translator.translate('generic.products.table.body.emptyDataSourceMessage')}
            />
        );
    }
}
function mapStateToProps(state, props) {
    const homeId = props.match.params.homeId;
    return {
        profile: selectors.getProfile(state),
        homeProducts: selectors.getProductsByHomeId(state, homeId)
    };
}

const styles = theme => ({
    associated: {
        color: theme.palette.success.main
    },
    dissociated: {
        color: theme.palette.error.main
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableHomeProducts)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/tables/TableHomeProducts.js